import { call, put, select } from "redux-saga/effects"
import { getCustomer, getSelectedTeamMembership } from "../selectors"
import * as client from "../../api/client"
import { makeToast } from "../../util/toast_util"
import * as actions from "../action_creators"
import { cardHolderNameIsValid } from "../../util/billing_info_utils"
import { handleFetchTeamAccountCustomer } from "./customer_sagas"

const SHOUTBASE_PAYMENT_PROBLEM = "There was a problem with your payment."
const SHOUTBASE_GENERAL_PROBLEM =
    "Sorry, something went wrong. Please try again."
const SHOUTBASE_NAME_REQUIRED = "Please enter a valid name on the card."
const SHOUTBASE_PAYMENT_SUCCESS = "Thanks for subscribing!"
const SHOUTBASE_PAYMENT_UPDATED = "Credit Card successfully updated."
const SHOUTBASE_CANCEL_PLAN_SUCESS = "Payment plan successfully canceled."

export function* handleGetStripeToken(name, stripe) {
    if (name === "" || !cardHolderNameIsValid(name)) {
        yield call(handleCreateStripeToast, SHOUTBASE_NAME_REQUIRED, "danger")
        return
    }

    const stripeResp = yield call(stripe.createToken, { name })

    // create toast on tokenization error
    if ("error" in stripeResp) {
        const { error } = stripeResp
        yield call(handleCreateStripeToast, error.message, "danger")
        return
    }

    const { token } = stripeResp
    return token
}

export function* handleSendStripeToken({ stripeTokenMeta }) {
    yield put(actions.setIsLoading(true))
    const token = yield call(
        handleGetStripeToken,
        stripeTokenMeta.name,
        stripeTokenMeta.stripe,
    )
    if (token) {
        const planName = stripeTokenMeta.planName || "Team"
        const { brand, last4, exp_month, exp_year } = token.card
        try {
            yield call(
                client.postStripeToken,
                token.id,
                planName,
                stripeTokenMeta.teamId,
                last4,
                brand,
                `${exp_month}/${exp_year}`,
            )

            // create toast on success
            yield call(
                handleCreateStripeToast,
                SHOUTBASE_PAYMENT_SUCCESS,
                "success",
            )
            yield call(handleFetchTeamAccountCustomer, {
                teamId: stripeTokenMeta.teamId,
            })
            yield put(actions.setIsLoading(false))
            yield put(actions.setPaymentModalOpen(false))
        } catch (e) {
            yield put(actions.setIsLoading(false))
            yield call(
                handleCreateStripeToast,
                SHOUTBASE_GENERAL_PROBLEM,
                "danger",
            )
            return
        }
    } else {
        yield put(actions.setIsLoading(false))
        yield call(handleCreateStripeToast, SHOUTBASE_PAYMENT_PROBLEM, "danger")
        return
    }
}

function* handleCreateStripeToast(msg, error) {
    yield call(makeToast, msg, error)
}

export function* handleCancelPlan() {
    const { id } = yield select(getCustomer)
    const { teamId } = yield select(getSelectedTeamMembership)

    try {
        yield call(client.deletePlan, id)

        // create toast on success
        yield call(
            handleCreateStripeToast,
            SHOUTBASE_CANCEL_PLAN_SUCESS,
            "success",
        )
        yield put(actions.fetchTeamAccountCustomer(teamId))
    } catch (e) {
        yield call(handleCreateStripeToast, SHOUTBASE_GENERAL_PROBLEM, "danger")
    }
}

export function* handleChangePaymentMethod({ name, stripe }) {
    yield put(actions.setIsLoading(true))
    const token = yield call(handleGetStripeToken, name, stripe)
    const { id } = yield select(getCustomer)
    const { teamId } = yield select(getSelectedTeamMembership)

    if (token) {
        try {
            const meta = { tokenId: token.id, customerId: id }
            yield call(client.putCustomerPaymentSourceUpdate, meta)

            // create toast on success
            yield call(
                handleCreateStripeToast,
                SHOUTBASE_PAYMENT_UPDATED,
                "success",
            )
            yield put(actions.setIsLoading(false))
            yield put(actions.setPaymentModalOpen(false))
            yield put(actions.fetchTeamAccountCustomer(teamId))
        } catch (e) {
            yield put(actions.setIsLoading(false))
            yield call(
                handleCreateStripeToast,
                SHOUTBASE_GENERAL_PROBLEM,
                "danger",
            )
            return
        }
    } else {
        yield put(actions.setIsLoading(false))
        yield call(handleCreateStripeToast, SHOUTBASE_PAYMENT_PROBLEM, "danger")
        return
    }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/payment_sagas.js